<myre-header
  [searchResults]="searchResults()"
  [auth$]="auth$"
  (searchItemClicked)="searchItemClicked.emit($event)"
  (searchUserInput)="searchUserInput.emit($event)"
/>

<mat-sidenav-container>
  <mat-sidenav mode="side" [opened]="_menuService.opened()">
    @if (_menuService._displayableMenu()) {
      <myre-side-nav />
    }
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="router-outlet">
      <router-outlet />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- Floating chat windows + footer bar -->
@if (_chatService.showChat()) {
  @for (window of _chatWindowService.windows(); track window.id) {
    <myre-chat-window
      [windowState]="window"
      [apiConfig]="chatApiConfig()"
      [welcomeIconUrl]="chatWelcomeIconUrl()"
      [welcomeIcon]="chatWelcomeIcon()"
    />
  }

  <myre-chat-footer-bar />
}
